var map = {
	"./poly-1.png": "4b15",
	"./poly-10.png": "e36a",
	"./poly-11.png": "e4d7",
	"./poly-12.png": "6a5a",
	"./poly-13.png": "3605",
	"./poly-14.png": "fac4",
	"./poly-2.png": "6542",
	"./poly-3.png": "1256",
	"./poly-4.png": "b29a",
	"./poly-5.png": "a667",
	"./poly-6.png": "8d60",
	"./poly-7.png": "4841",
	"./poly-8.png": "1dc3",
	"./poly-9.png": "0600"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ab5b";